import type { IANATimezones } from '@gcv/shared';

import { DateTimeHelpers } from 'util/dateTime.util';

/** Blank until the first save — "Auto-saved" against a never-saved record would be a lie. */
export const getAutoSaveLabel = (
  isSaving: boolean,
  dateUpdated: string | undefined,
  timezone: IANATimezones | undefined
): string => {
  if (isSaving) {
    return 'Saving...';
  }

  if (!dateUpdated) {
    return '';
  }

  return `Auto-saved: ${DateTimeHelpers.formatISODateStringToTableDateAndTimeString(dateUpdated, timezone)}`;
};
